import { Container, Grid, Image, Section } from '@/components/Core'
import { Lib } from '@/types'
import clsx from 'clsx'
import { readFragment } from 'gql.tada'
import { memo } from 'react'
import SectionImageListFragment from './query'

export interface SectionImageListProps {
  data: Lib.FragmentOf<typeof SectionImageListFragment>
}

export type SectionImageListData = Lib.FragmentOf<
  typeof SectionImageListFragment
> & {
  _modelApiKey: 'section_image_list'
  __typename: 'SectionImageListRecord'
  id: string
}

const SectionImageList = ({ data }: SectionImageListProps) => {
  const d = readFragment(SectionImageListFragment, data)

  return (
    <Section
      id={d.id || undefined}
      sectionName={d._modelApiKey}
      anim="section-fade-in"
      className={clsx('py-3xl', d?.background === 'gray' && 'bg-neutral-300')}
    >
      <Container>
        <Grid>
          <div className="gap-2xl col-span-12 grid grid-cols-2 md:col-span-10 md:col-start-2 md:grid-cols-3">
            {d.images?.map((image, index) => (
              <div key={index} className="">
                <Image data={image} fitWrap className="w-full" />
              </div>
            ))}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default memo(SectionImageList)
